export class QuickLaunchSetting {
  formIds: string[];
  object: string;
  username: string;

  constructor() {}
}
